document.addEventListener('DOMContentLoaded', function () {
  /**
   * Global Functions
   */
  function isVisibleElement(el) {
    return !!(el && el.offsetParent !== null)
  }

  function getProductQuantity() {
    var $inpQuantity = document.querySelector('.quantity__input')

    if (!$inpQuantity) {
      return 1
    }

    return parseInt($inpQuantity.value) || 1
  }

  function getProductPrice() {
    var $regularPrice = document.querySelector('.price .price-item.price-item--regular')
    var $salesPrice = document.querySelector('.price .price-item.price-item--sale.price-item--last')

    if ($salesPrice && isVisibleElement($salesPrice)) {
      var salesPrice = ($salesPrice.textContent || '')
          .replace('$', '')
          .replace('AUD', '')
          .trim();

      return parseFloat(salesPrice);
    }

    var regularPrice = ($regularPrice.textContent || '')
        .replace('$', '')
        .replace('AUD', '')
        .trim();

    return parseFloat(regularPrice);
  }

  function updateBundleTotalPrice() {
    var $inpAddons = document.querySelector('input.ci-step-summary-addons')
    var $bundlePrices = document.querySelectorAll('.ci-step-summary-bundle-price')

    var totalPrice = (getProductPrice() * getProductQuantity())
    var arrSelectedAddons = []

    document.querySelectorAll('.ci-bundle-product-checkbox').forEach(function (el) {
      if (el.checked) {
        var $closestWrapper = el.closest('.ci-bundle-product-wrapper')
        var $inpQty = $closestWrapper.querySelector('.ci-bundle-product-quantity')
        var addonQty = $inpQty ? parseInt($inpQty.value || '1') : 1

        totalPrice += parseFloat(el.getAttribute('data-price') || '0') * addonQty
        arrSelectedAddons.push(el.getAttribute('data-title') || '')
      }
    })

    document.querySelectorAll('.ci-bundle-product-dropdown').forEach(function (el) {
      var selectedOption = el.options[el.selectedIndex];

      if (selectedOption && selectedOption.value) {
        totalPrice += parseFloat(selectedOption.getAttribute('data-price') || '0')
        arrSelectedAddons.push(selectedOption.getAttribute('data-title') || '')
      }
    })

    if ($inpAddons) {
      $inpAddons.value = arrSelectedAddons.join(',')
    }

    if ($bundlePrices.length) {
      $bundlePrices.forEach(function (el) {
        el.textContent = '$' + totalPrice.toFixed(2) + ' AUD'
      })
    }
  }

  function addAddonsEvent() {
    document.querySelectorAll('.ci-bundle-product-checkbox').forEach(function (el) {
      el.addEventListener('change', updateBundleTotalPrice)
    })

    document.querySelectorAll('.ci-bundle-product-dropdown').forEach(function (el) {
      el.addEventListener('change', updateBundleTotalPrice)
    })
  }

  function getAddonsForCart() {
    var arrSelectedAddons = [];

    document.querySelectorAll('.ci-bundle-product-checkbox').forEach(function (el) {
      if (el.checked) {
        var $closestWrapper = el.closest('.ci-bundle-product-wrapper')
        var $inpQty = $closestWrapper.querySelector('.ci-bundle-product-quantity')
        var addonQty = $inpQty ? parseInt($inpQty.value || '1') : 1

        arrSelectedAddons.push({
          id: el.value,
          quantity: addonQty
        })
      }
    })

    document.querySelectorAll('.ci-bundle-product-dropdown').forEach(function (el) {
      var selectedOption = el.options[el.selectedIndex];

      if (selectedOption && selectedOption.value) {
        arrSelectedAddons.push({
          id: selectedOption.value,
          quantity: 1
        })
      }
    })

    return arrSelectedAddons
  }

  /**
   * Onload
   */
  addAddonsEvent();
  updateBundleTotalPrice();

  /**
   * Bundle add-on controls (checkbox pill + quantity stepper)
   */
  function isAddToBundleButtonClicked(e) {
    var isButton = e.target.classList.contains('ci-btn-add-to-bundle')
    var $closestButton = e.target.closest('.ci-btn-add-to-bundle')

    return isButton || $closestButton
  }

  function handleAddToBundleButton(e) {
    var $closestWrapper = e.target.closest('.ci-bundle-product-wrapper')
    var $inpQty = $closestWrapper.querySelector('.ci-bundle-product-quantity')
    var $checkbox = $closestWrapper.querySelector('.ci-bundle-product-checkbox')

    if ($checkbox) {
      $checkbox.checked = true
    }

    if ($inpQty) {
      $inpQty.value = 1
    }
  }

  function isQuantityInputChanged(e) {
    return e.target.classList.contains('ci-bundle-product-quantity')
  }

  function isQuantityDecrementButtonClicked(e) {
    var isButton = e.target.classList.contains('ci-btn-decrement-qty')
    var $closestButton = e.target.closest('.ci-btn-decrement-qty')

    return isButton || $closestButton
  }

  function handleQuantityDecrementButton(e) {
    var $closestWrapper = e.target.closest('.ci-bundle-product-wrapper')
    var $inpQty = $closestWrapper.querySelector('.ci-bundle-product-quantity')
    var $checkbox = $closestWrapper.querySelector('.ci-bundle-product-checkbox')

    if ($inpQty) {
      var currentValue = parseInt($inpQty.value, 10) || 0
      // Prevent negative values
      var newValue = Math.max(currentValue - 1, 0)
      $inpQty.value = newValue;

      if ($checkbox && newValue === 0) {
        $checkbox.checked = false
      }
    }
  }

  function isQuantityIncrementButtonClicked(e) {
    var isButton = e.target.classList.contains('ci-btn-increment-qty')
    var $closestButton = e.target.closest('.ci-btn-increment-qty')

    return isButton || $closestButton
  }

  function handleQuantityIncrementButton(e) {
    var $closestWrapper = e.target.closest('.ci-bundle-product-wrapper')
    var $inpQty = $closestWrapper.querySelector('.ci-bundle-product-quantity')
    var $checkbox = $closestWrapper.querySelector('.ci-bundle-product-checkbox')

    if ($inpQty) {
      var currentValue = parseInt($inpQty.value, 10) || 0
      // For safety although it won't happen
      // Prevent negative values
      var newValue = Math.max(currentValue + 1, 0)
      $inpQty.value = newValue;

      // For safety although it won't happen
      if ($checkbox && newValue === 0) {
        $checkbox.checked = false
      }
    }
  }

  document.body.addEventListener('click', function (e) {
    if (isAddToBundleButtonClicked(e)) {
      handleAddToBundleButton(e)
      updateBundleTotalPrice()
    }

    if (isQuantityDecrementButtonClicked(e)) {
      handleQuantityDecrementButton(e)
      updateBundleTotalPrice()
    }

    if (isQuantityIncrementButtonClicked(e)) {
      handleQuantityIncrementButton(e)
      updateBundleTotalPrice()
    }
  })

  document.body.addEventListener('change', function (e) {
    if (isQuantityInputChanged(e)) {
      updateBundleTotalPrice()
    }
  })

  /**
   * Product - Add To Cart (one-step + add-on modal)
   */
  var $formAddToCart = document.querySelector('form[action^="/cart/add"][data-type="add-to-cart-form"]')
  var $addonsModal = document.querySelector('#CiAddonsModal')

  if (!$formAddToCart) {
    return
  }

  function request(url, options) {
    if (window.fetch) {
      return fetch(url, options)
    }

    // Fallback for older browsers
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest()
      xhr.open(options.method || 'GET', url, true)

      if (options.headers) {
        Object.keys(options.headers).forEach(function (key) {
          xhr.setRequestHeader(key, options.headers[key])
        })
      }

      xhr.onload = function () {
        resolve({
          ok: xhr.status >= 200 && xhr.status < 300,
          status: xhr.status,
          json: function () {
            return Promise.resolve(JSON.parse(xhr.responseText))
          }
        })
      }

      xhr.onerror = reject
      xhr.send(options.body || null)
    })
  }

  function addMainProduct(hasMany) {
    // IMPORTANT: build the payload from the product form so any inputs the
    // Buunto widget injects into it (delivery date / postcode / etc.) are sent.
    var formData = new FormData($formAddToCart)

    request('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw e })
          return res.json()
        })
        .then(function () {
          var cartNotification = document.querySelector('cart-notification')
          if (!cartNotification) return

          var heading = cartNotification.querySelector('.cart-notification__heading')

          if (heading) {
            heading.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"></path></svg>' + (hasMany ? 'Items added to your cart' : 'Item added to your cart')
          }

          // This is what NEVER crashes
          if (typeof cartNotification.open === 'function') {
            cartNotification.open()
          }
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err)
        })
  }

  function addAddonsThenMainProduct(arrAddons) {
    var xhr = new XMLHttpRequest()
    xhr.open('POST', '/cart/add.js', true)
    xhr.setRequestHeader('Content-Type', 'application/json')

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          addMainProduct(true)
        } else {
          // Error handling: parse error if possible
          var errorMsg = 'Something went wrong. Please try again.'

          try {
            var response = JSON.parse(xhr.responseText)
            if (response && response.description) {
              errorMsg = response.description
            }
          } catch (e) {}

          alert(errorMsg)
        }
      }
    }

    xhr.onerror = function () {
      alert('Network error. Please check your internet connection.')
    }

    xhr.send(JSON.stringify({
      items: arrAddons
    }))
  }

  function hasAddons() {
    return document.querySelectorAll('.ci-bundle-product-checkbox, .ci-bundle-product-dropdown').length > 0
  }

  function openAddonsModal(opener) {
    if ($addonsModal && typeof $addonsModal.show === 'function') {
      $addonsModal.show(opener)
      updateBundleTotalPrice()
    }
  }

  function closeAddonsModal() {
    if ($addonsModal && typeof $addonsModal.hide === 'function') {
      $addonsModal.hide()
    }
  }

  // Actually add to the cart. includeAddons=false -> main product only.
  function submitAddToCart(includeAddons) {
    var arrAddons = includeAddons ? getAddonsForCart() : []

    if (arrAddons.length === 0) {
      addMainProduct(false)
      return
    }

    addAddonsThenMainProduct(arrAddons)
  }

  /**
   * Primary "Add to cart" button(s) from buy-buttons.
   * If this product has add-ons, open the modal instead of adding straight away.
   * The modal's own buttons (.add-product-only / .ci-modal-add-bundle) do the add.
   */
  document.querySelectorAll('button.product-form__submit:not(.add-product-only)').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()

      if (hasAddons() && $addonsModal) {
        openAddonsModal(el)
        return
      }

      submitAddToCart(false)
    })
  })

  /**
   * Modal: "Add to cart with these extras"
   */
  document.querySelectorAll('.ci-modal-add-bundle').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()
      closeAddonsModal()
      submitAddToCart(true)
    })
  })

  /**
   * Modal: "No thanks, add only this to my cart"
   */
  document.querySelectorAll('button.product-form__submit.add-product-only').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault()
      closeAddonsModal()
      submitAddToCart(false)
    })
  })
})
